/* eslint-disable no-prototype-builtins */

export const isStructureWithoutData = (item) => item.type === 'structure' && !item.structureData;

export const isAdvancedWithoutValue = (item) => item.type === 'advanced' && !item.value;

export const isExist = (item) => item.canExist;

// Helper function to check if children have no values
const hasNoValues = (children) => {
  if (!children || children.length === 0) return true;
  return children.every((child) => !child.hasOwnProperty('value') || !child.value);
};

// Helper function to check if an item should be considered valid
const isValidItem = (item) => isStructureWithoutData(item) || isAdvancedWithoutValue(item);

// Helper function to check wrapper items recursively
const checkWrapperItems = (items) => {
  if (!items || items.length === 0) return true;

  return items.every((item) => {
    if (isValidItem(item)) return true;

    if (item.exist) return false;

    if (item.id === 'wrapper' && item.items?.length > 0) {
      return checkWrapperItems(item.items);
    }

    if (item.children?.length > 0) {
      return hasNoValues(item.children);
    }

    return false;
  });
};

export const checkChildrenValues = (nodesList) => {
  if (!nodesList || nodesList.length === 0) return true;

  return nodesList.every((item) => {
    if (isValidItem(item)) return true;

    if (item.exist) return false;

    if (item.children?.length > 0) {
      return hasNoValues(item.children);
    }

    if (item.id === 'wrapper' && item.items?.length > 0) {
      return checkWrapperItems(item.items);
    }

    return false;
  });
};
